<div>
	<div class="px-20 mt-5">
		<img class="h-20" src="/assets/images/integrations/title-plus-logo.svg" />
	</div>
</div>

<div *ngIf="loading" class="flex flex-col items-center justify-center mt-5">
	<div class="flex gap-4">
		<app-icon [icon]="ICON.LOADING" [spin]="true"></app-icon>
	</div>
</div>
<div *ngIf="loadingError" class="flex flex-col items-center justify-center">
	<div>There was an error loading the mappings</div>
	<div class="mt-10 flex gap-10">
		<app-button (click)="close()" size="small">Close</app-button>
		<app-button (click)="loadMappings()" size="small">Reload</app-button>
	</div>
</div>
<form
	*ngIf="!loading && !loadingError"
	class="flex flex-col items-center"
	#form="ngForm"
	(ngSubmit)="save(form)"
>
	<div
		class="flex flex-col items-center justify-center mt-2"
		*ngIf="(userRole$ | async) === businessUserRole.LAWYER"
	>
		<h4>Enter a LSN</h4>
		<p class="text-sm">Enter your LSN below.</p>
	</div>
	<div
		class="flex flex-col items-center justify-center mt-2"
		*ngIf="(userRole$ | async) === businessUserRole.CLERK"
	>
		<h4>Manage lawyer LSNs</h4>
		<p class="text-sm">
			Enter and manage LSNs for lawyers within your firm below.
		</p>
	</div>

	<div
		class="border border-t-0 border-grey-lighter rounded-xl max-w-400 max-h-80 overflow-y-auto mt-8 w-full"
	>
		<table class="dashboard-table w-full">
			<thead class="bg-grey-veryLight rounded-xl p-3">
				<tr class="h-8">
					<td
						class="border-b py-6 border-grey-veryLight font-bold"
						*ngIf="(userRole$ | async) === businessUserRole.LAWYER"
					>
						Lawyer
					</td>
					<td
						class="border-b border-grey-veryLight font-bold"
						*ngIf="(userRole$ | async) === businessUserRole.CLERK"
					>
						Lawyer name
					</td>
					<td class="border-b border-grey-veryLight">
						<div class="flex flex-col">
							<p class="font-bold">LSN</p>
						</div>
					</td>
				</tr>
			</thead>
			<tbody>
				<tr
					*ngFor="let mapping of mappedLawyers"
					class="even:bg-grey-veryLight p-3"
				>
					<td>{{ mapping.name }}</td>
					<td>
						<app-input
							[name]="mapping.name + '\'s id'"
							[(ngModel)]="mapping.lsn"
							[submitted]="form.submitted"
						></app-input>
					</td>
				</tr>
			</tbody>
		</table>
	</div>

	<!-- <app-profile-id-message></app-profile-id-message> -->

	<div class="mt-10 flex w-full justify-between">
		<app-button btn="border" (click)="close()">Close</app-button>
		<app-button type="submit" [loading]="saving" [disabled]="!form.valid"
			>Save</app-button
		>
	</div>
	<div *ngIf="savingError" [@openClose]>
		<atomic-message-bar
			>There was an issue saving the LSN's. Please try
			again.</atomic-message-bar
		>
	</div>
</form>
